import BrandColors from "../../../../styles/BrandColors";

const { JLLBrandColors } = BrandColors;
const { Red, Black, Success, Green, Concrete, ComponentColors } =
  JLLBrandColors;
const config = {
  chartColors: {
    stateColors: {
      inProgress: Red.core,
      inApproval: Green.tint75Percent,
      approved: Success,
      expired: ComponentColors.ScoreIndicators.expired,
      rejected: ComponentColors.ScoreIndicators.block,
      incomplete: ComponentColors.ScoreIndicators.noScore,
    },
    entityColors: {
      legalPerson: "#003F55",
      naturalPerson: "#007DAA",
      others: "#AAE9FF",
    },
    checkColors: {
      kyc: "#626468",
      aml: "#D0C9B7",
      total: "#E30613",
    },
    color1: Black.core, // shade of black
    color2: Red.core, // shade of red
    color3: "#9A97C7", // shade of blue
    color4: "#885A98", // shade of violet
    color5: "#9A054A", // shade of pink
    color6: "#F19447", // shade of orange
    color7: Concrete.core, // shade of grey
    statusColors: {
      "no score": ComponentColors.ScoreIndicators.noScore,
      low: ComponentColors.ScoreIndicators.low,
      medium: ComponentColors.ScoreIndicators.medium,
      high: ComponentColors.ScoreIndicators.high,
      blocked: ComponentColors.ScoreIndicators.block,
      expired: ComponentColors.ScoreIndicators.expired,
    },
  },
};

export default config;
